import { Edit } from '@assets/svg';
import Button from '@components/Button/Button';
import Flex from '@components/Flex/Flex';
import LabelValueText from '@components/LabelValueText/LabelValueText';
import Text from '@components/Text/Text';
import { useTheme } from '@mui/material';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import { Container } from './ProfileInfoCard.styles';
import { ProfileInfoCardProps } from './ProfileInfoCard.types';

const ProfileInfoCard: React.FC<ProfileInfoCardProps> = ({
  title,
  rightButtonTitle = GlobalIntlSingleton.intl.formatMessage({
    id: 'misc.edit',
  }),
  data,
  children,
  hideRightButton = false,
  rightButtonTestId = 'profile-edit-button',
  onRightButtonPress,
  sx,
}) => {
  const { sm: isMobile } = useMediaQueries();
  const theme = useTheme();
  return (
    <Container sx={sx}>
      <Flex justifyContent='space-between'>
        <Text
          variant='h5'
          fontWeight='fontWeightBold'
          color={theme.palette.black.A100}
        >
          {title}
        </Text>
        {!hideRightButton && (
          <Button
            sx={{ width: isMobile ? 50 : 'auto' }}
            data-testid={rightButtonTestId}
            onClick={onRightButtonPress}
            variant='tertiary'
          >
            {isMobile ? <Edit style={{ marginTop: 5 }} /> : rightButtonTitle}
          </Button>
        )}
      </Flex>
      <Flex mt={5} gap={6} flexDirection='column'>
        {data.map((x, i) => (
          <LabelValueText
            key={x.label}
            {...x}
            hideButtonBorder={data.length === i + 1}
          />
        ))}
        {children}
      </Flex>
    </Container>
  );
};

export default ProfileInfoCard;
